import PropTypes from 'prop-types';
import React, { Component } from 'react';

import './read-more.scss';

class ReadMore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      isTruncated: false
    };
  }

  componentDidMount() {
    this.updateTruncateFlag();
    window.addEventListener('resize', this.updateTruncateFlag);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateTruncateFlag);
  }

  UNSAFE_componentWillReceiveProps() {
    this.updateTruncateFlag();
  }

  updateTruncateFlag = () => {
    if (this._contents && this._contents.scrollHeight > this.props.height) {
      this.setState({isTruncated: true});
    }
  }

  toggle = (e) => {
    this.setState({expanded: !this.state.expanded});
  }

  render() {
    const {children, more, less, height} = this.props;
    const {expanded, isTruncated} = this.state;
    let style = {maxHeight: height}, button = null, classes = ['contents'];
    if (expanded && isTruncated) {
      classes.push('expanded');
      button = <div className="read-less-link"><a href={'#' + this.props.id}><span onClick={this.toggle}>{less}</span></a></div>;
    } else if (isTruncated) {
      classes.push('truncated');
      button = <div className="read-more-link"><span onClick={this.toggle}>{more}</span></div>;
    }
    return (
      <div className="read-more" id={this.props.id}>
        <div className={classes.join(' ')} style={style} ref={ref => this._contents = ref}>
          {children}
        </div>
        {button}
      </div>
    );
  }
}

ReadMore.defaultProps = {
  //height: 400,
  id: 'read-more',
  more: 'Read more',
  less: 'Show less'
};

ReadMore.propTypes = {
  children: PropTypes.node.isRequired,
  height: PropTypes.number,
  id: PropTypes.string,
  less: PropTypes.string,
  more: PropTypes.string
};

export default ReadMore;


// WEBPACK FOOTER //
// ./src/components/shared/read-more/index.js